import { RoutingStep } from '../../../../../../../../models/Routes';
import SellerBrowsePortfolio from './pages/SellerBrowsePortfolio';
import ListingDetailSeller from './subrouters/ListingDetailSeller/Router';
import listingDetailSellerRouterRoutes from './subrouters/ListingDetailSeller/routes';

export default [
  {
    index: true,
    element: SellerBrowsePortfolio,
    labelId: 'browseListings',
    stepName: 'browseListings',
  },
  {
    path: ':id',
    element: ListingDetailSeller,
    labelId: 'listingDetails',
    stepName: 'listingDetails',
    routes: listingDetailSellerRouterRoutes,
  },
] as Array<RoutingStep>;
